module.exports = __webpack_public_path__ + "img/text.f634773f.svg";